import React, {useEffect, useState} from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import {ActionButton, FormGroup} from "./components/FormComps"
import {useIntlEx} from "./components/IntlUtils.js"
import {useSolv} from "./components/SolvProvider";
import {closeDialog, ModalDialog} from "./components/DialogUtils";
import {mkHref} from "./components/AccountUtils";
import {InfoBlock, InfoText} from "./components/ValidationUtils";
import getLogger from "./components/Logging.js"
import './App.css'

const log = getLogger("BroadcastOverrideDialog")

export default function BroadcastOverrideDialog(props)  {

  const {env, api, session, setBusy, setFatal} = useSolv()
  const {intl} = useIntlEx()

  const [adCampaignId, setAdCampaignId] = useState(null)

  const [alert, setAlert] = useState(null)

  useEffect(() => {
    if (props.adCampaignId) {
      setAdCampaignId(props.adCampaignId)
    }
  }, [props])

  async function handleApproveClick() {
    try {
      const payload = {
        adCampaignId: adCampaignId,
      }
      setBusy(intl.msg("working"))
      api.approveBroadcast(props.tenant.tenantId, props.broadcastId, payload)
        .then((data) => {
          window.location = mkHref({suffix: `/broadcasts`, tenant: props.tenant, user: session.user})
        })
        .catch((error) => {
          setAlert({type: "error", text: intl.msg("error_failed")})
        })
        .finally(() => {
          setBusy(null)
        })
    }
    catch (error) {
      // log.debug("ERROR!!!!", error)
      setAlert({type: "error", text: intl.msg("error_failed")})
    }
  }

  function handleOpenDialog() {
    setAdCampaignId(null)
  }

  function handleCloseDialog() {
    closeDialog(props.id || `dlg_broadcast_override`)
  }

  function handleAdCampaignIdChange(e) {
    const value = e.target.value
    setAdCampaignId(value)
  }

  return (
    <>
      <ModalDialog
        dialogId={props.id || `dlg_broadcast_override`}
        size={props.size || "md"}
        keyboard={"true"}
        backdrop={props.backdrop || "static"}
        onOpen={handleOpenDialog}
        onClose={handleCloseDialog}>

        <ModalDialog.Header
          title={intl.msg(`broadcast_override_title`)}
          description={intl.msg(`broadcast_override_subtitle`)}
          alert={alert}/>

        <ModalDialog.Body>

          {/*<p className="">{intl.msg(`${props.type}_export_text`)}</p>*/}

          <FormGroup>
            <FormGroup.Label text={intl.msg(`ad_campaign_id`)} description={intl.msg(`ad_campaign_id_description`, {brand: env.brandName})}/>
            <FormGroup.Controls>
              <input id="inp_ad_campaign_id" name="adCampaignId" type="text" className="form-control" value={adCampaignId} disabled={false} onChange={handleAdCampaignIdChange} autoComplete="off"/>
              <InfoBlock>
                <InfoText validate="required">{intl.msg("helptext_required")}</InfoText>
              </InfoBlock>
            </FormGroup.Controls>
          </FormGroup>

        </ModalDialog.Body>

        <ModalDialog.Footer>
          <ModalDialog.Footer.Controls>
            <ActionButton name="cancel" flavor="secondary" onClick={handleCloseDialog}/>
            <ActionButton name="approve" flavor="primary" disabled={adCampaignId?.trim()?.length === 0} onClick={handleApproveClick}/>
          </ModalDialog.Footer.Controls>
        </ModalDialog.Footer>

      </ModalDialog>
    </>
  )
}